// extracted by mini-css-extract-plugin
export var separator = "teleformulaire-module--separator--894de";
export var teleformContainer = "teleformulaire-module--teleform-container--40aad";
export var teleformFooter = "teleformulaire-module--teleform-footer--66f66";
export var teleformFooterDate = "teleformulaire-module--teleform-footer-date--c510a";
export var teleformLibre = "teleformulaire-module--teleform-libre--cc57f";
export var teleformLinks = "teleformulaire-module--teleform-links--f1059";
export var teleformLinksItem = "teleformulaire-module--teleform-links-item--ba348";
export var teleformLinksItemTitle = "teleformulaire-module--teleform-links-item-title--c94fa";
export var teleformLinksList = "teleformulaire-module--teleform-links-list--3cfe2";
export var teleformLinksTitle = "teleformulaire-module--teleform-links-title--9da3e";
export var teleformTaxo = "teleformulaire-module--teleform-taxo--078f0";
export var teleformTaxoItem = "teleformulaire-module--teleform-taxo-item--4b1d5";
export var teleformTitle = "teleformulaire-module--teleform-title--76c99";
export var teleformulaire = "teleformulaire-module--teleformulaire--c983c";